import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { rootActions } from 'Store';

interface ChangeShowPlanUpgradeSuccessPage {
  (showPlanUpgradeSuccessPage: boolean): void;
}

export default () => {
  const dispatch = useDispatch();

  const changeShowPlanUpgradeSuccessPage: ChangeShowPlanUpgradeSuccessPage = useCallback(
    showPlanUpgradeSuccessPage => {
      dispatch(
        rootActions.user.changeShowPlanUpgradeSuccessPage({ showPlanUpgradeSuccessPage }),
      );
    },
    [dispatch],
  );

  return [changeShowPlanUpgradeSuccessPage] as const;
};
